import apiClient, { extractData } from "../api-client";

const printPdfFilename = (response) => {
  const disposition = response.headers?.["content-disposition"] || "";
  const match = disposition.match(/filename="?([^";]+)"?/i);
  return match?.[1] || "lich-giao-hang.pdf";
};

export const deliveryScheduleApi = {
  get(params) {
    return apiClient.get("/delivery-schedule", { params }).then(extractData);
  },

  // Không timeout: PDF có ảnh demo, "In tất cả" hàng trăm đơn dễ quá 30s mặc định.
  printPdf(scope = "both") {
    return apiClient
      .get("/delivery-schedule/print.pdf", { params: { scope }, responseType: "blob", timeout: 0 })
      .then((response) => ({
        blob: response.data,
        filename: printPdfFilename(response),
      }));
  },
};

export default deliveryScheduleApi;
